import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { concat, EMPTY, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Returns a stream of the current ui - language. If it emits, it's guaranteed that the language files for the new language are already loaded
 */
export function currentLocaleStream(translate: TranslateService): Observable<string> {
  const currentLang = translate.getCurrentLang();
  // ngx-translate stopped exposing a public api to check if translations are loaded, so we have to access the internal store directly
  // eslint-disable-next-line dot-notation
  const translationAlreadyLoaded = translate['store'].getTranslations(currentLang);

  const waitTillLoaded$ = translationAlreadyLoaded ? of(true) : EMPTY;
  return concat(
    // get latest language
    waitTillLoaded$.pipe(map(() => translate.getCurrentLang())),
    translate.onLangChange.pipe(map(event => event.lang))
  );
}

/**
 * Creates a signal which will always contain the currently selected language.
 * @param translateService - optional: instance of the TranslateService, if not given it will be injected (only works in DI context)
 */
export function currentLocaleSignal(translateService?: TranslateService): Signal<string> {
  const translate = translateService ?? inject(TranslateService);
  return toSignal(currentLocaleStream(translate));
}
